import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import "../../Assets/CSS/Styles.scss";

const JobDetail = () => {
  const { id } = useParams(); // Get job ID from URL
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: '',
    emailAddress: '',
    message: '',
  });
  const [file, setFile] = useState(null);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`http://localhost:8000/api/jobs/${id}`) // Fetch single job
      .then((res) => {
        if (res.data.success) {
          setJob(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch job:", err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => data.append(key, value));
    data.append('resume', file);

    try {
      await axios.post('http://localhost:8000/api/getintouch', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setSuccess('Your application has been submitted!');
      setError('');
      setFormData({ fullName: '', mobileNumber: '', emailAddress: '', message: '' });
      setFile(null);
    } catch (err) {
      console.error(err);
      setError('Failed to submit the form.');
      setSuccess('');
    }
  };

  if (loading) {
    return <p className="text-center py-10">Loading job details...</p>;
  }

  if (!job) {
    return <p className="text-center py-10">Job not found.</p>;
  }

  return (
    <div className="font-sans antialiased text-gray-800 bg-gray-100 min-h-screen py-12 mt60">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12 border border-gray-200">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Left Column */}
            <div className="lg:col-span-2">
              <div className="mb-8 pb-4 border-b border-gray-200">
                <h1 className="text-3xl md:text-4xl font-bold text-[#FFA500] mb-2">
                  Position: {job.position}
                </h1>
                <div className="flex flex-wrap items-center text-gray-600 text-sm md:text-base space-x-4">
                  <span>📍 {job.workMode}</span>
                  <span>💼 {job.workType}</span>
                  <span>⏳ Experience: {job.experience}</span>
                </div>
              </div>

              <div className="mb-8">
                <h2 className="text-xl md:text-2xl font-bold mb-4">JOB OVERVIEW</h2>
                <p>{job.overview}</p>
              </div>

              {job.responsibilities?.length > 0 && (
                <div className="mb-8">
                  <h2 className="text-xl md:text-2xl font-bold mb-4">RESPONSIBILITIES</h2>
                  <ul className="list-disc list-inside space-y-2">
                    {job.responsibilities.map((resp, i) => (
                      <li key={i}>{resp}</li>
                    ))}
                  </ul>
                </div>
              )}

              {job.qualification?.length > 0 && (
                <div className="mb-8">
                  <h2 className="text-xl md:text-2xl font-bold mb-4">QUALIFICATION</h2>
                  <ul className="list-disc list-inside space-y-2">
                    {job.qualification.map((qual, i) => (
                      <li key={i}>{qual}</li>
                    ))}
                  </ul>
                </div>
              )}

              {job.skills?.length > 0 && (
                <div>
                  <h2 className="text-xl md:text-2xl font-bold mb-4">SKILLS</h2>
                  <ul className="list-disc list-inside space-y-2">
                    {job.skills.map((skill, i) => (
                      <li key={i}>{skill}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Right Column */}
            <div className="lg:col-span-1 bg-gray-50 p-6 rounded-lg shadow-inner border border-gray-200 h-fit">
              <h2 className="text-xl md:text-2xl font-bold mb-6 text-center">Apply For This Job</h2>

              {success && <p className="text-green-600 text-sm mb-4 text-center">{success}</p>}
              {error && <p className="text-red-600 text-sm mb-4 text-center">{error}</p>}

              <form className="space-y-4" onSubmit={handleSubmit}>
                <input type="text" id="fullName" placeholder="Full Name *" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border rounded-md" />
                <input type="tel" id="mobileNumber" placeholder="Mobile Number *" value={formData.mobileNumber} onChange={handleChange} required className="w-full px-4 py-2 border rounded-md" />
                <input type="email" id="emailAddress" placeholder="Email *" value={formData.emailAddress} onChange={handleChange} required className="w-full px-4 py-2 border rounded-md" />
                <textarea id="message" placeholder="Tell us about yourself" rows="4" value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border rounded-md" />
                <input type="file" id="resume" accept=".pdf,.doc,.docx" onChange={handleFileChange} required className="w-full text-sm" />
                <button type="submit" className="w-full bg-[#FFA500] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#e69500] transition-colors">Submit Resume</button>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetail;
